import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ActivityExceptionsQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date'];
  endDate: Types.Scalars['Date'];
  courierIds: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
  skip: Types.Scalars['Int'];
  take: Types.Scalars['Int'];
}>;


export type ActivityExceptionsQuery = { __typename?: 'Query', ActivityExceptions?: { __typename?: 'ActivityExceptionsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ActivityException', courierId: number, date: any, noOfCustomItineraryComputations: number }> | null } | null };


export const ActivityExceptionsDocument = gql`
    query ActivityExceptions($startDate: Date!, $endDate: Date!, $courierIds: [Int!]!, $skip: Int!, $take: Int!) {
  ActivityExceptions(
    startDate: $startDate
    endDate: $endDate
    courierIds: $courierIds
    skip: $skip
    take: $take
  ) {
    items {
      courierId
      date
      noOfCustomItineraryComputations
    }
    totalCount
  }
}
    `;

/**
 * __useActivityExceptionsQuery__
 *
 * To run a query within a React component, call `useActivityExceptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityExceptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityExceptionsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      courierIds: // value for 'courierIds'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useActivityExceptionsQuery(baseOptions: Apollo.QueryHookOptions<ActivityExceptionsQuery, ActivityExceptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityExceptionsQuery, ActivityExceptionsQueryVariables>(ActivityExceptionsDocument, options);
      }
export function useActivityExceptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityExceptionsQuery, ActivityExceptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityExceptionsQuery, ActivityExceptionsQueryVariables>(ActivityExceptionsDocument, options);
        }
export type ActivityExceptionsQueryHookResult = ReturnType<typeof useActivityExceptionsQuery>;
export type ActivityExceptionsLazyQueryHookResult = ReturnType<typeof useActivityExceptionsLazyQuery>;
export type ActivityExceptionsQueryResult = Apollo.QueryResult<ActivityExceptionsQuery, ActivityExceptionsQueryVariables>;